import { render, staticRenderFns } from "./GrabArea.vue?vue&type=template&id=fc51e66a&scoped=true&"
import script from "./GrabArea.vue?vue&type=script&lang=js&"
export * from "./GrabArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc51e66a",
  null
  
)

export default component.exports